import { render } from "./leave-index.vue?vue&type=template&id=54d6de8c"
import script from "./leave-index.vue?vue&type=script&lang=js"
export * from "./leave-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__